import { render, staticRenderFns } from "./CRUDEventProspects.vue?vue&type=template&id=18bc970b"
import script from "./CRUDEventProspects.vue?vue&type=script&lang=js"
export * from "./CRUDEventProspects.vue?vue&type=script&lang=js"
import style0 from "./CRUDEventProspects.vue?vue&type=style&index=0&id=18bc970b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports